(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chi-siamo"] && !Shopify.designMode) return;
  try {
    
  const marquees = document.querySelectorAll('[data-chi-siamo-marquee]');

  marquees.forEach((marquee) => {
    let resumeTimer;

    const pause = () => {
      marquee.classList.add('is-paused');
      window.clearTimeout(resumeTimer);
    };

    const resumeSoon = () => {
      window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(() => {
        marquee.classList.remove('is-paused');
      }, 1800);
    };

    marquee.addEventListener('pointerdown', pause);
    marquee.addEventListener('pointerup', resumeSoon);
    marquee.addEventListener('pointercancel', resumeSoon);
    marquee.addEventListener('touchstart', pause, { passive: true });
    marquee.addEventListener('touchend', resumeSoon);
    marquee.addEventListener('wheel', () => {
      pause();
      resumeSoon();
    }, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["come-funziona"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-come-funziona]');
    if (!sections.length) return;

    sections.forEach(function (section) {
      if (section.dataset.cfBound === 'true') return;
      section.dataset.cfBound = 'true';

      /* ─── Tabs ─── */
      const tablist = section.querySelector('[role="tablist"]');
      const tabs = tablist ? Array.from(tablist.querySelectorAll('[role="tab"]')) : [];
      const panels = Array.from(section.querySelectorAll('[role="tabpanel"]'));

      function syncInlineVideos(panel, shouldPlay) {
        panel.querySelectorAll('video[data-inline-autoplay-video]').forEach(function (video) {
          video.muted = true;
          video.defaultMuted = true;
          if (shouldPlay) {
            try { const p = video.play(); if (p && typeof p.catch === 'function') p.catch(function(){}); } catch (e) {}
          } else {
            try { video.pause(); } catch (e) {}
          }
        });
      }

      function activateTab(tab) {
        tabs.forEach(function (t) {
          t.setAttribute('aria-selected', 'false');
          t.classList.remove('come-funziona__tab--active');
          t.setAttribute('tabindex', '-1');
        });
        panels.forEach(function (p) {
          p.hidden = true;
          p.classList.remove('come-funziona__panel--active');
        });

        tab.setAttribute('aria-selected', 'true');
        tab.classList.add('come-funziona__tab--active');
        tab.setAttribute('tabindex', '0');

        const panelId = tab.getAttribute('aria-controls');
        const panel = document.getElementById(panelId);
        if (panel) {
          panel.hidden = false;
          panel.classList.add('come-funziona__panel--active');
          syncInlineVideos(panel, true);
        }
        panels.forEach(function (p) { if (p.hidden) syncInlineVideos(p, false); });
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () { activateTab(tab); });
      });

      if (tablist) {
        tablist.addEventListener('keydown', function (e) {
          const currentIndex = tabs.indexOf(document.activeElement);
          if (currentIndex === -1) return;
          let newIndex;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); newIndex = (currentIndex + 1) % tabs.length; }
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); newIndex = (currentIndex - 1 + tabs.length) % tabs.length; }
          else if (e.key === 'Home') { e.preventDefault(); newIndex = 0; }
          else if (e.key === 'End') { e.preventDefault(); newIndex = tabs.length - 1; }
          if (newIndex !== undefined) { tabs[newIndex].focus(); activateTab(tabs[newIndex]); }
        });
      }

      const initiallyActiveTab = tabs.find(function (t) { return t.getAttribute('aria-selected') === 'true'; });
      if (initiallyActiveTab) activateTab(initiallyActiveTab);

      /* ─── Per-panel dialog wiring ─── */
      panels.forEach(function (panel) {
        const dialog = panel.querySelector('[data-cf-dialog]');
        if (!dialog) return;

        const stage = dialog.querySelector('[data-cf-stage]');
        const slides = Array.from(dialog.querySelectorAll('[data-cf-slide]'));
        const videos = slides.map(function (s) { return s.querySelector('video'); });
        const triggers = panel.querySelectorAll('[data-cf-open]');
        const closeButtons = dialog.querySelectorAll('[data-cf-close]');
        let lastTrigger = null;

        function pauseAll() {
          videos.forEach(function (v) { if (v) try { v.pause(); } catch (e) {} });
        }

        function jumpToSlide(index) {
          const slide = slides[index];
          if (!slide || !stage) return;
          const top = slide.offsetTop;
          const prevSnap = stage.style.scrollSnapType;
          stage.style.scrollSnapType = 'none';
          stage.scrollTop = top;
          requestAnimationFrame(function () {
            stage.scrollTop = top;
            requestAnimationFrame(function () {
              stage.style.scrollSnapType = prevSnap;
            });
          });
        }

        function playSlide(video) {
          if (!video) return;
          video.currentTime = 0;
          video.muted = false;
          video.defaultMuted = false;
          video.removeAttribute('muted');
          video.volume = 1;
          const p = video.play();
          if (p && typeof p.catch === 'function') {
            p.catch(function () {
              video.muted = true;
              try { video.play(); } catch (e) {}
            });
          }
        }

        function openAt(index) {
          if (typeof dialog.showModal !== 'function') {
            dialog.setAttribute('open', '');
          } else if (!dialog.open) {
            dialog.showModal();
          }
          document.body.style.overflow = 'hidden';
          jumpToSlide(index);
          pauseAll();
          const v = videos[index];
          if (v) playSlide(v);
        }

        function close() {
          pauseAll();
          document.body.style.overflow = '';
          if (dialog.open && typeof dialog.close === 'function') {
            dialog.close();
          } else {
            dialog.removeAttribute('open');
          }
          if (lastTrigger && typeof lastTrigger.focus === 'function') {
            lastTrigger.focus();
          }
        }

        triggers.forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            lastTrigger = btn;
            const idx = parseInt(btn.getAttribute('data-cf-index') || '0', 10);
            openAt(idx);
          });
        });

        closeButtons.forEach(function (b) {
          b.addEventListener('click', function () { close(); });
        });

        dialog.addEventListener('close', function () {
          pauseAll();
          document.body.style.overflow = '';
        });

        dialog.addEventListener('cancel', function (e) {
          /* Esc key — let the default close happen */
        });

        /* Click on backdrop closes (dialog itself is the backdrop target) */
        dialog.addEventListener('click', function (e) {
          if (e.target === dialog) close();
        });

        /* Update active slide on scroll for future polish */
        if (stage && 'IntersectionObserver' in window) {
          const io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
                const slide = entry.target;
                const idx = parseInt(slide.getAttribute('data-cf-slide-index') || '0', 10);
                pauseAll();
                const v = videos[idx];
                if (v && dialog.open) playSlide(v);
              }
            });
          }, { root: stage, threshold: [0.6] });
          slides.forEach(function (s) { io.observe(s); });
        }
      });
    });

    /* Re-init on Shopify editor section reload */
    document.addEventListener('shopify:section:load', function () {
      document.querySelectorAll('[data-come-funziona]').forEach(function (s) {
        s.dataset.cfBound = 'false';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-product-slideshow"] && !Shopify.designMode) return;
  try {
    
  class HeroPsCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.hero-ps__track');
      this.slides = [...this.querySelectorAll('.hero-ps__slide')];
      this.cards = [...this.querySelectorAll('.hero-ps__card[href]')];
      this.current = 0;
      this.startX = 0;
      this.startY = 0;

      this.querySelector('.hero-ps__arrow--prev')?.addEventListener('click', () => this.go(-1));
      this.querySelector('.hero-ps__arrow--next')?.addEventListener('click', () => this.go(1));

      this.track.addEventListener('touchstart', (e) => {
        this.startX = e.touches[0].clientX;
        this.startY = e.touches[0].clientY;
      }, { passive: true });
      this.track.addEventListener('touchend', (e) => {
        const diffX = this.startX - e.changedTouches[0].clientX;
        const diffY = this.startY - e.changedTouches[0].clientY;
        const threshold = this.track.clientWidth * 0.55;
        if (Math.abs(diffX) > threshold && Math.abs(diffX) > Math.abs(diffY)) {
          this.go(diffX > 0 ? 1 : -1);
        }
      }, { passive: true });

      this.prefetched = new Set();
      this.cards.forEach((card) => {
        const prefetch = () => this.prefetch(card.href);
        card.addEventListener('pointerenter', prefetch, { passive: true });
        card.addEventListener('focus', prefetch, { passive: true });
        card.addEventListener('touchstart', prefetch, { passive: true });
      });
    }

    prefetch(href) {
      if (!href || this.prefetched.has(href)) return;
      this.prefetched.add(href);
      const link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = href;
      document.head.appendChild(link);
    }

    go(direction) {
      this.classList.add('is-animating');
      this.current = (this.current + direction + this.slides.length) % this.slides.length;

      for (const [i, slide] of this.slides.entries()) {
        const isActive = i === this.current;
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');

        const video = slide.querySelector('video');
        if (video) {
          if (isActive) {
            video.currentTime = 0;
            video.play();
          } else {
            video.pause();
          }
        }
      }

      window.clearTimeout(this.animationTimer);
      this.animationTimer = window.setTimeout(() => {
        this.classList.remove('is-animating');
      }, 520);
    }
  }

  if (!customElements.get('hero-ps-carousel')) {
    customElements.define('hero-ps-carousel', HeroPsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-reels"] && !Shopify.designMode) return;
  try {
    
  function initInspire() {
    for (const section of document.querySelectorAll('.inspire')) {
      const modal = section.querySelector('.inspire__modal');
      const player = section.querySelector('.inspire__player');
      const closeBtn = section.querySelector('.inspire__modal-close');
      const soundButton = section.querySelector('.inspire__sound');
      const counter = section.querySelector('.inspire__counter');
      const hint = section.querySelector('.inspire__hint');
      const cards = [...section.querySelectorAll('[data-inspire-index]')];
      if (!modal || !player || cards.length === 0) continue;

      let previousScrollY = 0;
      let activeIndex = 0;
      let touchStartY = 0;
      let wheelLocked = false;
      let hintTimer;

      function updateCounter() {
        if (counter) counter.textContent = `${activeIndex + 1} / ${cards.length}`;
      }

      function showHint() {
        if (!hint) return;
        window.clearTimeout(hintTimer);
        hint.dataset.visible = 'true';
        hintTimer = window.setTimeout(function () {
          hint.dataset.visible = 'false';
        }, 2600);
      }

      function loadVideo(index, playAudio) {
        const card = cards[index];
        if (!card || !card.dataset.inspireVideo) return;
        activeIndex = index;
        player.pause();
        if (card.dataset.inspirePoster) {
          player.setAttribute('poster', card.dataset.inspirePoster);
        } else {
          player.removeAttribute('poster');
        }
        player.innerHTML = `<source src="${card.dataset.inspireVideo}" type="video/mp4">`;
        player.load();
        player.currentTime = 0;
        player.defaultMuted = !playAudio;
        player.muted = !playAudio;
        player.volume = 1;
        if (soundButton) {
          soundButton.setAttribute('aria-pressed', playAudio ? 'false' : 'true');
          soundButton.setAttribute('aria-label', playAudio ? 'Mute' : 'Unmute');
        }
        player.play().catch(function () {});
        updateCounter();
      }

      function step(direction) {
        if (cards.length < 2) return;
        const nextIndex = (activeIndex + direction + cards.length) % cards.length;
        loadVideo(nextIndex, !player.muted);
      }

      function lockPageScroll() {
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
      }

      function unlockPageScroll() {
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
      }

      function openModal(index) {
        const card = cards[index];
        if (!card || !card.dataset.inspireVideo) return;
        loadVideo(index, true);

        previousScrollY = window.scrollY;
        document.body.style.width = '100%';
        document.body.style.position = 'fixed';
        document.body.style.top = '-' + previousScrollY + 'px';
        lockPageScroll();
        modal.showModal();
        showHint();
      }

      function closeModal() {
        modal.close();
        player.pause();
        player.removeAttribute('poster');
        player.removeAttribute('src');
        player.innerHTML = '';
        unlockPageScroll();
        document.body.style.width = '';
        document.body.style.position = '';
        document.body.style.top = '';
        window.scrollTo({ top: previousScrollY, behavior: 'instant' });
      }

      section.addEventListener('click', function (e) {
        const card = e.target.closest('[data-inspire-index]');
        if (!card) return;
        openModal(parseInt(card.dataset.inspireIndex, 10));
      });

      soundButton?.addEventListener('click', function () {
        const nextMuted = !player.muted;
        player.muted = nextMuted;
        player.defaultMuted = nextMuted;
        soundButton.setAttribute('aria-pressed', nextMuted ? 'true' : 'false');
        soundButton.setAttribute('aria-label', nextMuted ? 'Unmute' : 'Mute');
        if (!nextMuted) {
          player.volume = 1;
          player.play().catch(function () {});
        }
      });

      modal.addEventListener('wheel', function (event) {
        if (!modal.open || cards.length < 2) return;
        event.preventDefault();
        if (wheelLocked) return;
        const delta = event.deltaY || 0;
        if (Math.abs(delta) < 8) return;
        wheelLocked = true;
        step(delta > 0 ? 1 : -1);
        window.setTimeout(function () { wheelLocked = false; }, 280);
      }, { passive: false });

      modal.addEventListener('touchstart', function (event) {
        touchStartY = event.touches[0].clientY;
      }, { passive: true });

      modal.addEventListener('touchend', function (event) {
        if (!modal.open || cards.length < 2) return;
        const diffY = touchStartY - event.changedTouches[0].clientY;
        if (Math.abs(diffY) > 40) step(diffY > 0 ? 1 : -1);
      }, { passive: true });

      if (closeBtn) closeBtn.addEventListener('click', closeModal);
      modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
      modal.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.preventDefault(); closeModal(); } });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInspire);
  } else {
    initInspire();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot() {
      const roots = document.querySelectorAll('[data-page-faq]');
      roots.forEach(init);
    }

    function init(root) {
      if (root.__pageFaqInit) return;
      root.__pageFaqInit = true;
      const input = root.querySelector('[data-page-faq-search]');
      const empty = root.querySelector('[data-page-faq-empty]');
      const status = root.querySelector('[data-page-faq-sr-status]');
      const groups = Array.from(root.querySelectorAll('[data-page-faq-group]'));
      const items = Array.from(root.querySelectorAll('[data-page-faq-item]'));
      if (!groups.length || !items.length) return;

      const initiallyOpen = new Map();
      groups.forEach((g) => initiallyOpen.set(g, g.hasAttribute('open')));

      function norm(s) {
        return (s || '')
          .toLowerCase()
          .normalize('NFD')
          .replace(/[̀-ͯ]/g, '');
      }

      function apply() {
        const q = norm(input ? input.value : '');
        const searching = q.length > 0;
        root.classList.toggle('is-searching', searching);
        let total = 0;

        groups.forEach((group) => {
          const children = group.querySelectorAll('[data-page-faq-item]');
          const visibleChildren = [];
          children.forEach((item) => {
            const match =
              q.length === 0 ||
              norm(item.dataset.searchable || '').includes(q);
            item.hidden = !match;
            if (match) visibleChildren.push(item);
          });

          const groupVisibleCount = visibleChildren.length;
          group.hidden = groupVisibleCount === 0;
          total += groupVisibleCount;

          const countEl = group.querySelector('[data-page-faq-group-count]');
          if (countEl) {
            if (q.length > 0) {
              countEl.textContent =
                groupVisibleCount +
                ' ' +
                (groupVisibleCount === 1 ? 'result' : 'results');
            } else {
              const total_n = children.length;
              countEl.textContent =
                total_n +
                ' ' +
                (total_n === 1 ? 'question' : 'questions');
            }
          }

          if (q.length > 0 && groupVisibleCount > 0) {
            group.open = true;
          } else if (q.length === 0) {
            group.open = initiallyOpen.get(group) || false;
          }
        });

        if (empty) empty.hidden = total > 0;
        if (status) {
          status.textContent =
            total > 0
              ? total +
                ' ' +
                (total === 1 ? 'question found' : 'questions found')
              : 'No questions found';
        }
      }

      if (input) {
        let timer = null;
        input.addEventListener('input', () => {
          clearTimeout(timer);
          timer = setTimeout(apply, 150);
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target && event.target.querySelector
        ? event.target.querySelector('[data-page-faq]')
        : null;
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pharmacist-testimonial"] && !Shopify.designMode) return;
  try {
    
  function initPharmacistSection() {
    for (const section of document.querySelectorAll('.pharmacist-section')) {
      const modal = section.querySelector('.pharmacist-section__modal');
      const player = section.querySelector('.pharmacist-section__player');
      const closeBtn = section.querySelector('.pharmacist-section__modal-close');
      const soundButton = section.querySelector('.pharmacist-section__sound');
      const counter = section.querySelector('.pharmacist-section__counter');
      const hint = section.querySelector('.pharmacist-section__hint');
      const cards = [...section.querySelectorAll('.pharm-card')];
      if (!modal || !player || cards.length === 0) continue;

      let previousScrollY = 0;
      let activeIndex = 0;
      let touchStartY = 0;
      let wheelLocked = false;
      let hintTimer;

      function sourceFor(index) {
        const card = cards[index];
        if (!card) return null;
        const source = card.dataset.videoSrc;
        return source ? { source, poster: card.dataset.videoPoster || '' } : null;
      }

      function updateCounter() {
        if (counter) counter.textContent = `${activeIndex + 1} / ${cards.length}`;
      }

      function showHint() {
        if (!hint) return;
        window.clearTimeout(hintTimer);
        hint.dataset.visible = 'true';
        hintTimer = window.setTimeout(function () {
          hint.dataset.visible = 'false';
        }, 2600);
      }

      function loadVideo(index, playAudio) {
        const data = sourceFor(index);
        if (!data) return;
        activeIndex = index;
        player.pause();
        player.setAttribute('poster', data.poster);
        player.innerHTML = `<source src="${data.source}" type="video/mp4">`;
        player.load();
        player.currentTime = 0;
        player.defaultMuted = !playAudio;
        player.muted = !playAudio;
        player.volume = 1;
        if (soundButton) {
          soundButton.setAttribute('aria-pressed', playAudio ? 'false' : 'true');
          soundButton.setAttribute('aria-label', playAudio ? 'Mute' : 'Unmute');
        }
        player.play().catch(function () {});
        updateCounter();
      }

      function step(direction) {
        if (cards.length < 2) return;
        const nextIndex = (activeIndex + direction + cards.length) % cards.length;
        loadVideo(nextIndex, !player.muted);
      }

      function lockPageScroll() {
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
      }

      function unlockPageScroll() {
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
      }

      function openModal(index) {
        const data = sourceFor(index);
        if (!data) return;
        loadVideo(index, true);

        previousScrollY = window.scrollY;
        document.body.style.width = '100%';
        document.body.style.position = 'fixed';
        document.body.style.top = '-' + previousScrollY + 'px';
        lockPageScroll();
        modal.showModal();
        showHint();
      }

      function closeModal() {
        modal.close();
        player.pause();
        player.removeAttribute('poster');
        player.removeAttribute('src');
        player.innerHTML = '';
        unlockPageScroll();
        document.body.style.width = '';
        document.body.style.position = '';
        document.body.style.top = '';
        window.scrollTo({ top: previousScrollY, behavior: 'instant' });
      }

      section.addEventListener('click', function (e) {
        const card = e.target.closest('.pharm-card');
        if (!card) return;
        openModal(parseInt(card.dataset.pharmIndex, 10) || 0);
      });

      soundButton?.addEventListener('click', function () {
        const nextMuted = !player.muted;
        player.muted = nextMuted;
        player.defaultMuted = nextMuted;
        soundButton.setAttribute('aria-pressed', nextMuted ? 'true' : 'false');
        soundButton.setAttribute('aria-label', nextMuted ? 'Unmute' : 'Mute');
        if (!nextMuted) {
          player.volume = 1;
          player.play().catch(function () {});
        }
      });

      modal.addEventListener('wheel', function (event) {
        if (!modal.open || cards.length < 2) return;
        event.preventDefault();
        if (wheelLocked) return;
        const delta = event.deltaY || 0;
        if (Math.abs(delta) < 8) return;
        wheelLocked = true;
        step(delta > 0 ? 1 : -1);
        window.setTimeout(function () { wheelLocked = false; }, 280);
      }, { passive: false });

      modal.addEventListener('touchstart', function (event) {
        touchStartY = event.touches[0].clientY;
      }, { passive: true });

      modal.addEventListener('touchend', function (event) {
        if (!modal.open || cards.length < 2) return;
        const diffY = touchStartY - event.changedTouches[0].clientY;
        if (Math.abs(diffY) > 40) step(diffY > 0 ? 1 : -1);
      }, { passive: true });

      if (closeBtn) closeBtn.addEventListener('click', closeModal);
      modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
      modal.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.preventDefault(); closeModal(); } });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPharmacistSection);
  } else {
    initPharmacistSection();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pharmacy-map"] && !Shopify.designMode) return;
  try {
    
  customElements.define(
    'pharmacy-map',
    class PharmacyMap extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-map-viewport]');
        this.svg = this.querySelector('.pharmacy-map__italy');
        this.pinsLayer = this.querySelector('[data-map-pins]');
        this.labelsLayer = this.querySelector('[data-map-labels]');
        this.card = this.querySelector('[data-map-card]');
        this.cardContent = this.querySelector('[data-map-card-content]');
        this.back = this.querySelector('[data-map-back]');
        this.backLabel = this.querySelector('[data-map-back-label]');
        this.hint = this.querySelector('[data-map-hint]');
        this.directory = this.querySelector('[data-map-directory]');
        if (!this.viewport || !this.svg || !this.pinsLayer) return;

        const vb = this.svg.viewBox.baseVal;
        const d = this.svg.dataset;
        this.proj = {
          lng0: +d.lng0,
          lat1: +d.lat1,
          cos: +d.cos,
          spanx: +d.spanx,
          spany: +d.spany,
          w: vb.width,
          h: vb.height,
        };

        this.regionPaths = Array.from(this.querySelectorAll('[data-map-region]'));
        this.provincePaths = [];
        this.regionOfSigla = new Map();
        this.labelItems = [];

        // Pin coordinates are computed server-side as % of the full map; keep the
        // base position so every zoom can re-place them against the live viewBox.
        this.pins = Array.from(this.querySelectorAll('[data-map-pin]')).map((el) => ({
          el,
          x: (parseFloat(el.style.getPropertyValue('--pin-x')) / 100) * this.proj.w,
          y: (parseFloat(el.style.getPropertyValue('--pin-y')) / 100) * this.proj.h,
        }));

        this.points = [];
        this.readPayload(this.pinsLayer);

        this.svg.addEventListener('click', (e) => {
          const prov = e.target.closest('[data-map-province]');
          const reg = prov ? null : e.target.closest('[data-map-region]');
          if (!prov && !reg) return;
          // A tap must not leave the path focused: the browser draws its ring
          // around the path's bbox, which the zoom blows up across the stage.
          if (e.detail > 0) (prov || reg).blur();
          this.select(prov ? { type: 'province', el: prov } : this.targetForRegion(reg));
        });
        this.svg.addEventListener('keydown', (e) => {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          if (!e.target.closest('[data-map-region], [data-map-province]')) return;
          e.preventDefault();
          e.target.dispatchEvent(new MouseEvent('click', { bubbles: true }));
        });
        // Pull the province layer down on the first touch of the map, so it is
        // already there by the time the second tap needs it.
        this.addEventListener('pointerdown', () => this.loadProvinces(), { once: true });

        this.back.addEventListener('click', () => this.select(this.parentView()));

        this.pinsLayer.addEventListener('click', (e) => {
          const pin = e.target.closest('[data-map-pin]');
          if (!pin) return;
          e.preventDefault();
          this.openCard(pin);
        });

        this.search = this.querySelector('[data-map-search]');
        this.searchMsg = this.querySelector('[data-map-search-msg]');
        this.search?.removeAttribute('hidden');
        this.search?.addEventListener('submit', (e) => {
          e.preventDefault();
          this.searchCap(this.querySelector('[data-map-search-input]').value);
        });

        this.querySelector('[data-map-card-close]')?.addEventListener('click', () => this.closeCard());
        this.addEventListener('keydown', (e) => {
          if (e.key !== 'Escape') return;
          if (!this.card.hidden) this.closeCard();
          else if (this.view.type !== 'italy') this.select(this.parentView());
        });

        this.select({ type: 'italy' });
        // The stage keeps the map aspect ratio, so a resize needs no re-fit —
        // only the label/pin layout depends on the box, and that is percentages.
      }

      readPayload(scope) {
        scope.querySelectorAll('[data-map-payload]').forEach((s) => {
          try {
            this.points.push(...JSON.parse(s.textContent));
          } catch (err) {
            /* malformed payload: pins still work as plain links */
          }
          s.remove();
        });
      }

      /* ---- Province layer: a theme asset, fetched once ---------------------- */

      loadProvinces() {
        if (this.provincesReady) return this.provincesReady;
        const url = this.dataset.provincesUrl;
        this.provincesReady = fetch(url)
          .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
          .then((text) => {
            const doc = new DOMParser().parseFromString(text, 'image/svg+xml');
            const host = this.querySelector('[data-map-provinces]');
            Array.from(doc.querySelectorAll('path')).forEach((path) =>
              host.appendChild(document.importNode(path, true))
            );
            this.provincePaths = Array.from(this.querySelectorAll('[data-map-province]'));
            this.regionOfSigla = new Map(this.provincePaths.map((p) => [p.dataset.mapProvince, p.dataset.region]));
          })
          .catch(() => {
            /* no provinces: the zone/region levels still work on their own */
          });
        return this.provincesReady;
      }

      regionsInZone(zone) {
        return this.regionPaths.filter((r) => r.dataset.zone === zone);
      }

      /* Where a tap on a region path leads, given where we are now.
         Inside the current selection it goes one level deeper; outside it moves
         sideways at the same depth, so you can hop from Nord-Ovest to Centro
         without zooming all the way out. Zones holding a single region
         (Sicilia, Sardegna) always resolve to the region. */
      targetForRegion(reg) {
        const view = this.view;
        const alone = this.regionsInZone(reg.dataset.zone).length === 1;
        const inside = view.regions?.includes(reg.dataset.mapRegion);
        if (view.type === 'italy') return alone ? { type: 'region', el: reg } : { type: 'zone', zone: reg.dataset.zone };
        if (view.type === 'zone') {
          if (inside) return { type: 'region', el: reg };
          return alone ? { type: 'region', el: reg } : { type: 'zone', zone: reg.dataset.zone };
        }
        return { type: 'region', el: reg };
      }

      /* ---- Drill-down state ------------------------------------------------ */

      parentView() {
        const v = this.view;
        if (v.type === 'province') {
          const reg = this.regionPaths.find((r) => r.dataset.mapRegion === v.region);
          return reg ? { type: 'region', el: reg } : { type: 'italy' };
        }
        if (v.type === 'region') {
          return this.regionsInZone(v.zone).length > 1 ? { type: 'zone', zone: v.zone } : { type: 'italy' };
        }
        return { type: 'italy' };
      }

      async select(target) {
        const view = { type: target.type };
        if (target.type === 'zone') {
          const members = this.regionsInZone(target.zone);
          view.zone = target.zone;
          view.label = target.zone;
          view.regions = members.map((r) => r.dataset.mapRegion);
          view.bbox = this.unionBbox(members);
        } else if (target.type === 'region') {
          const el = target.el;
          view.region = el.dataset.mapRegion;
          view.zone = el.dataset.zone;
          view.label = el.dataset.label;
          view.regions = [view.region];
          view.bbox = this.parseBbox(el.dataset.bbox);
        } else if (target.type === 'province') {
          const el = target.el;
          view.sigla = el.dataset.mapProvince;
          view.region = el.dataset.region;
          view.zone = this.regionPaths.find((r) => r.dataset.mapRegion === view.region)?.dataset.zone;
          view.label = el.dataset.label;
          view.regions = [view.region];
          view.bbox = this.parseBbox(el.dataset.bbox);
        }

        this.view = view;
        this.closeCard();
        this.paintRegions(view);
        this.filterPins(view);
        this.updateControls(view);
        this.animateTo(this.rectFor(view.bbox));
        if (view.type === 'region' || view.type === 'province') await this.loadProvinces();
        if (this.view !== view) return; // a newer selection landed while fetching
        this.paintProvinces(view);
        this.renderLabels(view);
      }

      parseBbox(str) {
        return str.split(',').map(Number); // latMax, lngMin, latMin, lngMax
      }

      unionBbox(els) {
        return els
          .map((el) => this.parseBbox(el.dataset.bbox))
          .reduce((a, b) => [Math.max(a[0], b[0]), Math.min(a[1], b[1]), Math.min(a[2], b[2]), Math.max(a[3], b[3])]);
      }

      /* ---- Zoom: one viewBox rect, animated ------------------------------- */

      rectFor(bbox) {
        const p = this.proj;
        if (!bbox) return { x: 0, y: 0, w: p.w, h: p.h };
        const [latMax, lngMin, latMin, lngMax] = bbox;
        const x0 = (((lngMin - p.lng0) * p.cos) / p.spanx) * p.w;
        const x1 = (((lngMax - p.lng0) * p.cos) / p.spanx) * p.w;
        const y0 = ((p.lat1 - latMax) / p.spany) * p.h;
        const y1 = ((p.lat1 - latMin) / p.spany) * p.h;
        const aspect = p.w / p.h; // the stage is locked to the map aspect
        const PAD = 1.14;
        const MAX_ZOOM = 16;
        let w = (x1 - x0) * PAD;
        let h = (y1 - y0) * PAD;
        if (w / h < aspect) w = h * aspect;
        else h = w / aspect;
        if (w < p.w / MAX_ZOOM) {
          w = p.w / MAX_ZOOM;
          h = w / aspect;
        }
        return { x: (x0 + x1) / 2 - w / 2, y: (y0 + y1) / 2 - h / 2, w, h };
      }

      animateTo(to) {
        const from = this.rect || { x: 0, y: 0, w: this.proj.w, h: this.proj.h };
        cancelAnimationFrame(this.raf);
        this.labelsLayer.removeAttribute('data-ready');
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.applyRect(to);
          return this.settleLabels();
        }
        const t0 = performance.now();
        const DUR = 520;
        const step = (now) => {
          const k = Math.min(1, (now - t0) / DUR);
          const e = 1 - Math.pow(1 - k, 3);
          this.applyRect({
            x: from.x + (to.x - from.x) * e,
            y: from.y + (to.y - from.y) * e,
            w: from.w + (to.w - from.w) * e,
            h: from.h + (to.h - from.h) * e,
          });
          if (k < 1) this.raf = requestAnimationFrame(step);
          else this.settleLabels();
        };
        this.raf = requestAnimationFrame(step);
      }

      /* Names are dense on a phone (12 province in Lombardia): keep the ones
         that matter — where there is a punto vendita, then the largest — and
         drop whatever would overlap them. Measured once, after the zoom lands. */
      settleLabels() {
        this.labelsLayer.setAttribute('data-ready', '');
        const placed = [];
        [...this.labelItems]
          .sort((a, b) => b.weight - a.weight)
          .forEach((l) => {
            l.el.style.visibility = '';
            if (l.el.hidden) return;
            const r = l.el.getBoundingClientRect();
            const clash = placed.some(
              (q) => r.right > q.left && r.left < q.right && r.bottom > q.top && r.top < q.bottom
            );
            if (clash) l.el.style.visibility = 'hidden';
            else placed.push(r);
          });
      }

      applyRect(r) {
        this.rect = r;
        this.svg.setAttribute('viewBox', `${r.x.toFixed(2)} ${r.y.toFixed(2)} ${r.w.toFixed(2)} ${r.h.toFixed(2)}`);
        const place = (el, x, y, inScope) => {
          const fx = (x - r.x) / r.w;
          const fy = (y - r.y) / r.h;
          const out = fx < -0.05 || fx > 1.05 || fy < -0.05 || fy > 1.05;
          el.hidden = out || !inScope;
          if (el.hidden) return;
          el.style.setProperty('--pin-x', `${(fx * 100).toFixed(2)}%`);
          el.style.setProperty('--pin-y', `${(fy * 100).toFixed(2)}%`);
          el.style.setProperty('--label-x', `${(fx * 100).toFixed(2)}%`);
          el.style.setProperty('--label-y', `${(fy * 100).toFixed(2)}%`);
        };
        this.pins.forEach((p) => place(p.el, p.x, p.y, p.el.dataset.scope === '1'));
        this.labelItems.forEach((l) => place(l.el, l.x, l.y, true));
      }

      /* ---- Painting -------------------------------------------------------- */

      paintRegions(view) {
        this.regionPaths.forEach((r) => {
          if (view.type === 'italy') {
            delete r.dataset.state;
            return;
          }
          r.dataset.state = view.regions.includes(r.dataset.mapRegion) ? 'active' : 'muted';
        });
      }

      paintProvinces(view) {
        const show = view.type === 'region' || view.type === 'province';
        this.provincePaths.forEach((p) => {
          const inRegion = show && p.dataset.region === view.region;
          if (!inRegion) {
            delete p.dataset.state;
            p.setAttribute('tabindex', '-1');
            return;
          }
          p.dataset.state = view.type === 'province' && p.dataset.mapProvince === view.sigla ? 'active' : 'on';
          p.setAttribute('tabindex', '0');
        });
      }

      /* Names appear only once you are inside a zone: on the full map they would
         be a wall of text over shapes everyone already recognises. */
      renderLabels(view) {
        const source =
          view.type === 'zone'
            ? this.regionsInZone(view.zone)
            : view.type === 'region' || view.type === 'province'
              ? this.provincePaths.filter((p) => p.dataset.region === view.region)
              : [];
        this.labelsLayer.textContent = '';
        this.labelItems = source.map((path) => {
          const [x, y] = path.dataset.anchor.split(',').map(Number);
          const el = document.createElement('span');
          el.className = 'pharmacy-map__label';
          el.textContent = path.dataset.label;
          const active = view.type === 'province' && path.dataset.mapProvince === view.sigla;
          if (active) el.dataset.state = 'active';
          const [latMax, lngMin, latMin, lngMax] = this.parseBbox(path.dataset.bbox);
          const area = (latMax - latMin) * (lngMax - lngMin);
          this.labelsLayer.appendChild(el);
          return { el, x, y, weight: (active ? 1000 : 0) + this.puntiFor(path) * 100 + area };
        });
        if (this.rect) this.applyRect(this.rect);
        requestAnimationFrame(() => this.settleLabels());
      }

      puntiFor(path) {
        const region = path.dataset.mapRegion;
        return this.points.filter((pt) =>
          region ? this.regionOfSigla.get(pt.provincia) === region : pt.provincia === path.dataset.mapProvince
        ).length;
      }

      filterPins(view) {
        this.visiblePoints = this.points.filter((pt) => this.inView(pt.provincia, view));
        const cities = new Set(this.visiblePoints.map((pt) => pt.citta));
        this.pins.forEach((p) => {
          p.el.dataset.scope = cities.has(p.el.dataset.city) ? '1' : '';
        });
        if (this.rect) this.applyRect(this.rect);
        this.updateCount(view);
      }

      inView(sigla, view) {
        if (view.type === 'italy') return true;
        if (view.type === 'province') return sigla === view.sigla;
        // Before the province layer lands, region scope falls back to everything.
        if (!this.regionOfSigla.size) return true;
        return view.regions.includes(this.regionOfSigla.get(sigla));
      }

      updateCount(view) {
        const el = this.querySelector('[data-map-count]');
        const txt = this.querySelector('[data-map-count-text]');
        if (!el || !txt) return;
        const total =
          view.type === 'italy' ? +this.pinsLayer.dataset.total || this.points.length : this.visiblePoints.length;
        const noun = total === 1 ? 'punto vendita' : 'punti vendita';
        let where = 'in tutta Italia';
        if (view.type === 'zone') where = `in ${view.label}`;
        else if (view.type === 'region') where = `in ${view.label}`;
        else if (view.type === 'province') where = `in provincia di ${view.label}`;
        txt.textContent = total ? `${total} ${noun} ${where}` : `Nessun punto vendita ${where}`;
        el.hidden = false;
      }

      updateControls(view) {
        this.hint.hidden = view.type !== 'italy';
        if (view.type === 'italy') {
          this.back.hidden = true;
          return;
        }
        const parent = this.parentView();
        this.backLabel.textContent =
          parent.type === 'italy' ? 'Tutta Italia' : parent.type === 'zone' ? parent.zone : parent.el.dataset.label;
        this.back.hidden = false;
      }

      /* ---- CAP search ------------------------------------------------------ */

      // "SIGLA:from-to,from;SIGLA:..." — an exact hit wins, otherwise the
      // numerically closest range, which in the Italian numbering is next door.
      siglaForCap(cap) {
        let best = null;
        for (const chunk of (this.dataset.capIndex || '').split(';')) {
          const [sigla, ranges] = chunk.split(':');
          if (!ranges) continue;
          for (const range of ranges.split(',')) {
            const [from, to] = range.split('-');
            const a = +from;
            const b = to ? +to : a;
            if (cap >= a && cap <= b) return sigla;
            const gap = cap < a ? a - cap : cap - b;
            if (!best || gap < best.gap) best = { sigla, gap };
          }
        }
        return best?.sigla || null;
      }

      async searchCap(raw) {
        const cap = +String(raw).replace(/\D/g, '');
        if (!cap || String(raw).replace(/\D/g, '').length !== 5) {
          this.searchMsg.textContent = 'Scrivi un CAP di 5 cifre, es. 09121.';
          return;
        }
        if (!this.points.length) return;
        this.searchMsg.textContent = 'Cerco…';
        await this.loadProvinces();
        const sigla = this.siglaForCap(cap);
        const path = this.provincePaths.find((p) => p.dataset.mapProvince === sigla);
        if (!path) {
          this.searchMsg.textContent = 'We couldn\'t find that ZIP code. Try the list below.';
          return;
        }
        const [latMax, lngMin, latMin, lngMax] = this.parseBbox(path.dataset.bbox);
        const from = { lat: (latMax + latMin) / 2, lng: (lngMin + lngMax) / 2 };
        const nearest = this.points
          .map((pt) => ({ pt, km: this.distanceKm(from, { lat: +pt.lat, lng: +pt.lng }) }))
          .sort((a, b) => a.km - b.km)[0];
        const target = this.provincePaths.find((p) => p.dataset.mapProvince === nearest.pt.provincia);
        if (target) await this.select({ type: 'province', el: target });
        this.showPoint(nearest.pt);
        this.searchMsg.textContent =
          nearest.pt.provincia === sigla
            ? `The closest store to ZIP code ${String(cap).padStart(5, '0')}: ${nearest.pt.nome}, ${nearest.pt.citta}.`
            : `No stores in ${path.dataset.label}. The closest one is ${nearest.pt.nome}, ${nearest.pt.citta} (${nearest.pt.provincia}).`;
      }

      distanceKm(a, b) {
        const R = 6371;
        const rad = (v) => (v * Math.PI) / 180;
        const dLat = rad(b.lat - a.lat);
        const dLng = rad(b.lng - a.lng);
        const s =
          Math.sin(dLat / 2) ** 2 + Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(dLng / 2) ** 2;
        return 2 * R * Math.asin(Math.sqrt(s));
      }

      showPoint(pt) {
        this.cardContent.textContent = '';
        this.renderSingle(pt);
        this.card.hidden = false;
        this.card.focus();
      }

      openCard(pin) {
        const city = pin.dataset.city;
        const cityPoints = this.points.filter((pt) => pt.citta === city);
        if (!cityPoints.length) {
          window.open(pin.href, '_blank', 'noopener');
          return;
        }
        this.cardContent.textContent = '';
        if (cityPoints.length === 1) this.renderSingle(cityPoints[0]);
        else this.renderList(city, cityPoints);
        this.lastFocused = pin;
        this.card.hidden = false;
        this.card.focus();
      }

      renderSingle(pt) {
        if (pt.logo) {
          const img = document.createElement('img');
          img.className = 'pharmacy-map__card-logo';
          img.src = pt.logo;
          img.alt = '';
          img.loading = 'lazy';
          this.cardContent.appendChild(img);
        }
        const title = document.createElement('p');
        title.className = 'pharmacy-map__card-title';
        title.textContent = pt.nome;
        const address = document.createElement('p');
        address.className = 'pharmacy-map__card-address';
        address.textContent = `${pt.indirizzo} — ${pt.citta} (${pt.provincia})`;
        const actions = document.createElement('div');
        actions.className = 'pharmacy-map__card-actions';
        actions.appendChild(this.directionsLink(pt, 'button'));
        if (pt.link) {
          const site = document.createElement('a');
          site.className = 'button button-secondary';
          site.href = pt.link;
          site.target = '_blank';
          site.rel = 'noopener nofollow';
          site.textContent = 'Sito';
          actions.appendChild(site);
        }
        this.cardContent.append(title, address, actions);
      }

      renderList(city, cityPoints) {
        const title = document.createElement('p');
        title.className = 'pharmacy-map__card-title';
        title.textContent = `${city} (${cityPoints[0].provincia}) — ${cityPoints.length} punti vendita`;
        const list = document.createElement('ul');
        list.className = 'pharmacy-map__card-list';
        cityPoints.forEach((pt) => {
          const row = document.createElement('li');
          row.className = 'pharmacy-map__card-row';
          const address = document.createElement('span');
          address.className = 'pharmacy-map__card-row-address';
          address.textContent = pt.indirizzo;
          row.append(address, this.directionsLink(pt, 'pharmacy-map__card-row-link'));
          list.appendChild(row);
        });
        this.cardContent.append(title, list);
      }

      directionsLink(pt, className) {
        const a = document.createElement('a');
        a.className = className;
        a.href = `https://www.google.com/maps/dir/?api=1&destination=${pt.lat},${pt.lng}`;
        a.target = '_blank';
        a.rel = 'noopener';
        a.textContent = 'Indicazioni';
        a.setAttribute('aria-label', `Directions to ${pt.nome}, ${pt.indirizzo}, ${pt.citta}`);
        return a;
      }

      closeCard() {
        this.card.hidden = true;
        this.lastFocused?.focus();
      }
    }
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-marquee"] && !Shopify.designMode) return;
  try {
    
  function initPressTickers(scope = document) {
    const tickers = scope.querySelectorAll('[data-bc-press-ticker]');

    tickers.forEach((ticker) => {
      if (ticker.dataset.ready === 'true') return;

      const track = ticker.querySelector('[data-bc-press-track]');
      const group = ticker.querySelector('[data-bc-press-group]');
      if (!track || !group || group.children.length === 0) return;

      const originalItems = Array.from(group.children);
      const minGroupWidth = ticker.offsetWidth + group.scrollWidth;

      while (group.scrollWidth < minGroupWidth) {
        originalItems.forEach((item) => {
          const itemClone = item.cloneNode(true);
          itemClone.setAttribute('aria-hidden', 'true');
          itemClone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
          group.appendChild(itemClone);
        });
      }

      const clone = group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-bc-press-group');
      clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));

      track.appendChild(clone);
      ticker.dataset.ready = 'true';
    });
  }

  initPressTickers();
  document.addEventListener('shopify:section:load', (event) => initPressTickers(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-before-after"] && !Shopify.designMode) return;
  try {
    
  class ProductBeforeAfter extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.product-before-after__track');
      this.slides = [...this.querySelectorAll('.product-before-after__card')];
      this.prevBtn = this.querySelector('[data-pba-prev]');
      this.nextBtn = this.querySelector('[data-pba-next]');
      if (!this.track || this.slides.length < 2) return;

      this.autoplayDelay = 5000;
      this.autoplayTimer = null;
      this.pausedByUser = false;
      this.track.style.scrollBehavior = 'smooth';

      this.prevBtn?.addEventListener('click', () => { this.pauseAutoplay(true); this.go(-1); });
      this.nextBtn?.addEventListener('click', () => { this.pauseAutoplay(true); this.go(1); });

      // Pause on hover, focus, touch
      this.addEventListener('mouseenter', () => this.pauseAutoplay(false));
      this.addEventListener('mouseleave', () => this.maybeResume());
      this.addEventListener('focusin', () => this.pauseAutoplay(false));
      this.addEventListener('focusout', () => this.maybeResume());
      this.track.addEventListener('touchstart', () => this.pauseAutoplay(true), { passive: true });

      // Respect reduced motion
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reduced) this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    currentIndex() {
      const scrollLeft = this.track.scrollLeft;
      let best = 0;
      let bestDist = Infinity;
      this.slides.forEach((s, i) => {
        const dist = Math.abs(s.offsetLeft - scrollLeft);
        if (dist < bestDist) { bestDist = dist; best = i; }
      });
      return best;
    }

    go(direction) {
      const cur = this.currentIndex();
      const total = this.slides.length;
      const next = (cur + direction + total) % total;
      const target = this.slides[next];
      if (target) {
        this.track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      }
    }

    startAutoplay() {
      this.stopAutoplay();
      this.autoplayTimer = setInterval(() => this.go(1), this.autoplayDelay);
    }

    stopAutoplay() {
      if (this.autoplayTimer) { clearInterval(this.autoplayTimer); this.autoplayTimer = null; }
    }

    pauseAutoplay(permanent) {
      if (permanent) this.pausedByUser = true;
      this.stopAutoplay();
    }

    maybeResume() {
      if (this.pausedByUser) return;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced) return;
      this.startAutoplay();
    }
  }

  if (!customElements.get('product-before-after')) {
    customElements.define('product-before-after', ProductBeforeAfter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-comparison"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('.product-comparison');
    sections.forEach(function (section) {
      const carousel = section.querySelector('[data-carousel]');
      const hint = section.querySelector('[data-carousel-hint]');
      const current = section.querySelector('[data-carousel-current]');
      const currentLabel = section.querySelector('[data-carousel-current-label]');
      if (!carousel) return;

      const slides = carousel.querySelectorAll('[data-slide-index]');
      if (slides.length === 0) return;

      function slideWidth() {
        const first = slides[0];
        if (!first) return carousel.clientWidth;
        const rect = first.getBoundingClientRect();
        return rect.width + parseFloat(getComputedStyle(carousel).columnGap || 0);
      }

      function currentIndex() {
        const w = slideWidth();
        if (!w) return 0;
        return Math.min(slides.length - 1, Math.max(0, Math.round(carousel.scrollLeft / w)));
      }

      function updateState() {
        const idx = currentIndex();
        if (current) current.textContent = String(idx + 1);
        if (currentLabel) {
          const activeSlide = slides[idx];
          const activeLabel = activeSlide?.querySelector('.product-comparison__col-label');
          currentLabel.textContent = activeLabel ? activeLabel.textContent.trim() : '';
        }
        if (hint) {
          // Always visible. Direction flips on the last slide (becomes "back to first").
          const isLast = idx === slides.length - 1;
          hint.classList.toggle('is-back', isLast);
          hint.setAttribute('aria-label', isLast ? 'Back to the first option' : 'See the next option');
        }
      }

      function scrollToIndex(idx) {
        const clamped = Math.min(slides.length - 1, Math.max(0, idx));
        carousel.scrollTo({ left: slideWidth() * clamped, behavior: 'smooth' });
      }

      if (hint) {
        hint.addEventListener('click', function () {
          const idx = currentIndex();
          if (idx >= slides.length - 1) {
            scrollToIndex(0);
          } else {
            scrollToIndex(idx + 1);
          }
        });
      }

      carousel.addEventListener('scroll', function () {
        window.requestAnimationFrame(updateState);
      });
      window.addEventListener('resize', updateState);

      // Pointer drag-to-slide (mouse + touch via Pointer Events)
      let dragStartX = 0;
      let dragStartScroll = 0;
      let dragging = false;
      let pointerId = null;

      carousel.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        pointerId = event.pointerId;
        dragStartX = event.clientX;
        dragStartScroll = carousel.scrollLeft;
        dragging = true;
        carousel.style.scrollSnapType = 'none';
        carousel.setPointerCapture(pointerId);
      });

      carousel.addEventListener('pointermove', function (event) {
        if (!dragging || event.pointerId !== pointerId) return;
        const dx = event.clientX - dragStartX;
        carousel.scrollLeft = dragStartScroll - dx;
      });

      function endDrag(event) {
        if (!dragging || event.pointerId !== pointerId) return;
        dragging = false;
        carousel.style.scrollSnapType = '';
        try { carousel.releasePointerCapture(pointerId); } catch (_e) {}
        pointerId = null;
        // Snap to nearest based on final scrollLeft
        const w = slideWidth();
        const nearest = Math.round(carousel.scrollLeft / w);
        scrollToIndex(nearest);
      }

      carousel.addEventListener('pointerup', endDrag);
      carousel.addEventListener('pointercancel', endDrag);

      // Auto-peek when section enters viewport (mobile only, once per session)
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const peekedKey = 'bcCmpPeeked';
      const isMobile = window.matchMedia('(max-width: 899px)').matches;
      let peeked = false;
      try { peeked = sessionStorage.getItem(peekedKey) === '1'; } catch (_e) {}

      if (!reduceMotion && !peeked && isMobile && 'IntersectionObserver' in window) {
        const obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && !peeked) {
              peeked = true;
              try { sessionStorage.setItem(peekedKey, '1'); } catch (_e) {}
              obs.disconnect();
              const peekDistance = Math.max(40, slideWidth() * 0.18);
              setTimeout(function () {
                carousel.scrollTo({ left: peekDistance, behavior: 'smooth' });
                setTimeout(function () {
                  carousel.scrollTo({ left: 0, behavior: 'smooth' });
                }, 700);
              }, 350);
            }
          });
        }, { threshold: 0.45 });
        obs.observe(section);
      }

      updateState();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-protocol"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const ROOT_SELECTOR = '[data-pp-root]';

    function bind(root) {
      if (root.dataset.ppBound === 'true') return;
      root.dataset.ppBound = 'true';

      const dialog = root.querySelector('[data-pp-dialog]');
      if (!dialog) return;

      const stage = dialog.querySelector('[data-pp-stage]');
      const slides = Array.from(dialog.querySelectorAll('[data-pp-slide]'));
      const videos = slides.map((s) => s.querySelector('video'));
      const closeButtons = dialog.querySelectorAll('[data-pp-close]');
      const triggers = root.querySelectorAll('[data-pp-open]');
      const hint = dialog.querySelector('[data-pp-hint]');
      let hintTimer = null;
      let lastTrigger = null;
      let activeIndex = 0;
      let wheelLock = false;

      const showHint = () => {
        if (!hint) return;
        hint.dataset.ppHintVisible = 'true';
        clearTimeout(hintTimer);
        hintTimer = setTimeout(() => {
          hint.dataset.ppHintVisible = 'false';
        }, 3200);
      };

      const hideHint = () => {
        if (!hint) return;
        hint.dataset.ppHintVisible = 'false';
        clearTimeout(hintTimer);
      };

      const pauseAll = () => {
        for (const v of videos) {
          if (!v) continue;
          v.pause();
        }
      };

      const jumpToSlide = (index) => {
        const slide = slides[index];
        if (!slide || !stage) return;
        activeIndex = index;
        const top = slide.offsetTop;
        const previousSnapType = stage.style.scrollSnapType;
        stage.style.scrollSnapType = 'none';
        stage.scrollTop = top;
        requestAnimationFrame(() => {
          stage.scrollTop = top;
          requestAnimationFrame(() => {
            stage.style.scrollSnapType = previousSnapType;
          });
        });
      };

      const smoothScrollToSlide = (index) => {
        const slide = slides[index];
        if (!slide || !stage) return;
        activeIndex = index;
        const top = slide.offsetTop;
        const previousBehavior = stage.style.scrollBehavior;
        stage.style.scrollBehavior = 'smooth';
        stage.scrollTo({ top });
        window.setTimeout(() => {
          stage.style.scrollBehavior = previousBehavior;
        }, 320);
      };

      const playSlide = async (video, { allowMutedFallback = true } = {}) => {
        if (!video) return;
        video.currentTime = 0;
        video.muted = false;
        video.defaultMuted = false;
        video.removeAttribute('muted');
        video.volume = 1;
        try {
          await video.play();
        } catch (_err) {
          if (!allowMutedFallback) return;
          video.muted = true;
          try { await video.play(); } catch (_e) { /* ignore */ }
        }
      };

      const activateSlideByIndex = (index) => {
        jumpToSlide(index);
        pauseAll();
        const video = videos[index];
        if (!video) return;
        playSlide(video, { allowMutedFallback: false });
      };

      let observer = null;
      const setupObserver = () => {
        if (observer || !stage) return;
        observer = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              const idx = Number(entry.target.dataset.ppSlideIndex);
              const video = videos[idx];
              if (!video) continue;
              if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
                activeIndex = idx;
                pauseAll();
                playSlide(video);
              }
            }
          },
          { root: stage, threshold: [0.6] }
        );
        for (const s of slides) observer.observe(s);
      };

      const teardownObserver = () => {
        if (!observer) return;
        observer.disconnect();
        observer = null;
      };

      for (const trigger of triggers) {
        trigger.addEventListener('click', () => {
          lastTrigger = trigger;
          const index = Number(trigger.dataset.ppIndex) || 0;
          if (typeof dialog.showModal === 'function') dialog.showModal();
          else dialog.setAttribute('open', '');
          document.documentElement.style.overflow = 'hidden';
          jumpToSlide(index);
          activateSlideByIndex(index);
          setupObserver();
          if (slides.length > 1) showHint();
        });
      }

      if (stage) {
        stage.addEventListener('scroll', hideHint, { passive: true });
        stage.addEventListener('wheel', (event) => {
          if (window.matchMedia('(max-width: 749px)').matches) return;
          if (Math.abs(event.deltaY) < 8) return;
          event.preventDefault();
          if (wheelLock) return;
          const direction = event.deltaY > 0 ? 1 : -1;
          const nextIndex = Math.max(0, Math.min(slides.length - 1, activeIndex + direction));
          if (nextIndex === activeIndex) return;
          wheelLock = true;
          smoothScrollToSlide(nextIndex);
          window.setTimeout(() => {
            wheelLock = false;
          }, 360);
        }, { passive: false });
      }

      const handleClose = () => {
        pauseAll();
        teardownObserver();
        hideHint();
        if (stage) stage.scrollTop = 0;
        activeIndex = 0;
        wheelLock = false;
        document.documentElement.style.overflow = '';
        if (typeof dialog.close === 'function') dialog.close();
        if (lastTrigger) {
          lastTrigger.focus();
          lastTrigger = null;
        }
      };

      for (const btn of closeButtons) btn.addEventListener('click', handleClose);

      dialog.addEventListener('cancel', (e) => {
        e.preventDefault();
        handleClose();
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) handleClose();
      });
    }

    const init = () => {
      for (const root of document.querySelectorAll(ROOT_SELECTOR)) bind(root);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const el = event.target;
      if (!el) return;
      const root = el.querySelector ? el.querySelector(ROOT_SELECTOR) : null;
      if (root) bind(root);
      else if (el.matches && el.matches(ROOT_SELECTOR)) bind(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-usp"] && !Shopify.designMode) return;
  try {
    
  class ProductUspRings extends HTMLElement {
    constructor() {
      super();
      this.animated = false;
    }

    connectedCallback() {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const rings = this.querySelectorAll('.product-usp__ring-fill');
      const nums = this.querySelectorAll('.product-usp__stat-num');

      if (reduceMotion) {
        rings.forEach((r) => {
          const target = parseFloat(r.dataset.target) || 0;
          r.setAttribute('stroke-dashoffset', String(Math.max(0, 100 - target)));
        });
        return;
      }

      if (!('IntersectionObserver' in window)) {
        this.animate(rings, nums);
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.animated) {
              this.animated = true;
              this.animate(rings, nums);
              this.observer.disconnect();
            }
          });
        },
        { threshold: 0.25 }
      );

      this.observer.observe(this);
    }

    animate(rings, nums) {
      rings.forEach((r) => {
        const target = parseFloat(r.dataset.target) || 0;
        const offset = Math.max(0, 100 - target);
        requestAnimationFrame(() => {
          r.setAttribute('stroke-dashoffset', String(offset));
        });
      });

      nums.forEach((el) => {
        const target = parseFloat(el.dataset.countTarget) || 0;
        const sym = el.querySelector('.product-usp__stat-sym');
        const duration = 1200;
        const start = performance.now();
        const tick = (now) => {
          const p = Math.min(1, (now - start) / duration);
          const eased = 1 - Math.pow(1 - p, 3);
          const value = Math.round(target * eased);
          el.firstChild.nodeValue = String(value);
          if (sym) el.appendChild(sym);
          if (p < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      });
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  if (!customElements.get('product-usp-rings')) {
    customElements.define('product-usp-rings', ProductUspRings);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-video-creators"] && !Shopify.designMode) return;
  try {
    
  class ProductVideoCreators extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound === 'true') return;
      this.dataset.bound = 'true';

      this.lastTrigger = null;

      const dialog = this.querySelector('[data-pvc-dialog]');
      const video = this.querySelector('[data-pvc-dialog-video]');
      const title = this.querySelector('[data-pvc-dialog-title]');
      const kicker = this.querySelector('[data-pvc-dialog-kicker]');
      const quote = this.querySelector('[data-pvc-dialog-quote]');
      if (!dialog || !video) return;

      const loadTriggerVideo = async (trigger) => {
        const src = trigger.dataset.pvcSrc;
        if (!src) return;
        video.pause();
        video.removeAttribute('src');
        video.innerHTML = '';
        const source = document.createElement('source');
        source.src = src;
        if (trigger.dataset.pvcType) source.type = trigger.dataset.pvcType;
        video.appendChild(source);
        if (trigger.dataset.pvcPoster) video.poster = trigger.dataset.pvcPoster;
        else video.removeAttribute('poster');
        title.textContent = trigger.dataset.pvcTitle || trigger.dataset.pvcQuote || 'Video community';
        if (trigger.dataset.pvcCreator) {
          kicker.hidden = false;
          kicker.textContent = trigger.dataset.pvcCreator;
        } else {
          kicker.hidden = true;
          kicker.textContent = '';
        }
        if (trigger.dataset.pvcQuote && trigger.dataset.pvcQuote !== title.textContent) {
          quote.hidden = false;
          quote.textContent = trigger.dataset.pvcQuote;
        } else {
          quote.hidden = true;
          quote.textContent = '';
        }
        video.load();
        video.currentTime = 0;
        video.muted = false;
        video.defaultMuted = false;
        video.removeAttribute('muted');
        video.volume = 1;
        try {
          await video.play();
        } catch (_error) {}
      };

      this.querySelectorAll('[data-pvc-trigger]').forEach((trigger) => {
        trigger.addEventListener('click', async () => {
          if (!trigger.dataset.pvcSrc) return;
          this.lastTrigger = trigger;
          if (typeof dialog.showModal === 'function') dialog.showModal();
          else dialog.setAttribute('open', '');
          await loadTriggerVideo(trigger);
          const closeBtn = dialog.querySelector('[data-pvc-close]');
          if (closeBtn) closeBtn.focus();
        });
      });

      dialog.querySelectorAll('[data-pvc-close]').forEach((button) => {
        button.addEventListener('click', () => dialog.close());
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });

      dialog.addEventListener('close', () => {
        video.pause();
        video.removeAttribute('src');
        video.innerHTML = '';
        if (this.lastTrigger) {
          this.lastTrigger.focus();
          this.lastTrigger = null;
        }
      });
    }
  }

  if (!customElements.get('product-video-creators')) {
    customElements.define('product-video-creators', ProductVideoCreators);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-video-how-to"] && !Shopify.designMode) return;
  try {
    
  class ProductVideoHowTo extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound === 'true') return;
      this.dataset.bound = 'true';

      this.lastTrigger = null;

      this.querySelectorAll('[data-pvht-trigger]').forEach((trigger) => {
        const dialogId = trigger.getAttribute('aria-controls');
        const dialog = this.querySelector('#' + CSS.escape(dialogId));
        if (!dialog) return;

        trigger.addEventListener('click', () => {
          if (!trigger.dataset.pvhtSrc) return;
          this.lastTrigger = trigger;
          if (typeof dialog.showModal === 'function') dialog.showModal();
          else dialog.setAttribute('open', '');

          const video = dialog.querySelector('[data-pvht-video]');
          const title = dialog.querySelector('[data-pvht-title]');
          const creator = dialog.querySelector('[data-pvht-creator]');
          if (video) {
            try {
              video.pause();
              video.removeAttribute('src');
              video.innerHTML = '';
              const source = document.createElement('source');
              source.src = trigger.dataset.pvhtSrc;
              if (trigger.dataset.pvhtType) source.type = trigger.dataset.pvhtType;
              video.appendChild(source);
              if (trigger.dataset.pvhtPoster) video.poster = trigger.dataset.pvhtPoster;
              else video.removeAttribute('poster');
              video.load();
              video.currentTime = 0;
              video.muted = false;
              video.defaultMuted = false;
              video.removeAttribute('muted');
              video.volume = 1;
              const playPromise = video.play();
              if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
            } catch (e) {}
          }
          if (title) title.textContent = trigger.dataset.pvhtTitle || 'How to use';
          if (creator) {
            if (trigger.dataset.pvhtCreator) {
              creator.hidden = false;
              creator.textContent = trigger.dataset.pvhtCreator;
            } else {
              creator.hidden = true;
              creator.textContent = '';
            }
          }
          const closeBtn = dialog.querySelector('[data-pvht-close]');
          if (closeBtn) closeBtn.focus();
        });
      });

      this.querySelectorAll('[data-pvht-dialog]').forEach((dialog) => {
        const closeBtn = dialog.querySelector('[data-pvht-close]');
        if (closeBtn) {
          closeBtn.addEventListener('click', () => dialog.close());
        }

        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) {
            dialog.close();
          }
        });

        dialog.addEventListener('close', () => {
          const video = dialog.querySelector('[data-pvht-video]');
          if (video) {
            try {
              video.pause();
              video.removeAttribute('src');
              video.innerHTML = '';
            } catch (e) {}
          }
          if (this.lastTrigger && typeof this.lastTrigger.focus === 'function') {
            this.lastTrigger.focus();
          }
        });
      });
    }
  }

  if (!customElements.get('product-video-how-to')) {
    customElements.define('product-video-how-to', ProductVideoHowTo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-video-pharmacists"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const ROOT_SELECTOR = '[data-pvp-root]';

    function bind(root) {
      if (root.dataset.pvpBound === 'true') return;
      root.dataset.pvpBound = 'true';

      const moreBtn = root.querySelector('[data-pvp-more]');
      if (moreBtn) {
        const step = Number(root.dataset.pvpStep) || 5;
        moreBtn.addEventListener('click', () => {
          const extras = root.querySelectorAll('[data-pvp-extra][hidden]');
          let revealed = 0;
          for (const el of extras) {
            if (revealed >= step) break;
            el.removeAttribute('hidden');
            revealed++;
          }
          if (!root.querySelector('[data-pvp-extra][hidden]')) {
            moreBtn.parentElement.hidden = true;
          }
        });
      }

      const dialog = root.querySelector('[data-pvp-dialog]');
      if (!dialog) return;

      const player = dialog.querySelector('[data-pvp-player]');
      const closeButtons = dialog.querySelectorAll('[data-pvp-close]');
      const triggers = root.querySelectorAll('[data-pvp-open]');
      const soundButton = dialog.querySelector('[data-pvp-sound]');
      const counter = dialog.querySelector('[data-pvp-counter]');
      const soundOnIcon = dialog.querySelector('[data-pvp-sound-on]');
      const soundOffIcon = dialog.querySelector('[data-pvp-sound-off]');
      const hint = dialog.querySelector('[data-pvp-hint]');
      let lastTrigger = null;
      let activeIndex = 0;
      let touchStartY = 0;
      let wheelLock = false;
      let hintTimer = null;
      const items = Array.from(triggers).map((trigger) => ({
        src: trigger.dataset.pvpSrc,
        type: trigger.dataset.pvpType,
        poster: trigger.dataset.pvpPoster || '',
      }));

      const updateUi = () => {
        if (counter) counter.textContent = `${activeIndex + 1} / ${items.length}`;
        if (soundButton && player) {
          const muted = !!player.muted;
          soundButton.setAttribute('aria-label', muted ? 'Unmute' : 'Mute');
          soundButton.setAttribute('aria-pressed', muted ? 'true' : 'false');
          if (soundOnIcon) soundOnIcon.hidden = muted;
          if (soundOffIcon) soundOffIcon.hidden = !muted;
        }
      };

      const showHintOnce = () => {
        if (!hint) return;
        hint.dataset.pvpHintVisible = 'true';
        window.clearTimeout(hintTimer);
        hintTimer = window.setTimeout(() => {
        hint.dataset.pvpHintVisible = 'false';
        }, 3600);
      };

      const loadItem = async (index) => {
        const item = items[index];
        if (!item || !player || !item.src) return;
        activeIndex = index;
        player.pause();
        player.removeAttribute('src');
        player.innerHTML = '';
        const source = document.createElement('source');
        source.src = item.src;
        if (item.type) source.type = item.type;
        player.appendChild(source);
        if (item.poster) player.poster = item.poster;
        else player.removeAttribute('poster');
        player.load();
        player.currentTime = 0;
        player.muted = false;
        player.defaultMuted = false;
        player.removeAttribute('muted');
        player.volume = 1;
        try { await player.play(); } catch (_error) {}
        updateUi();
      };

      const stepBy = (direction) => {
        const nextIndex = Math.max(0, Math.min(items.length - 1, activeIndex + direction));
        if (nextIndex === activeIndex) return;
        loadItem(nextIndex);
      };

      for (const trigger of triggers) {
        trigger.addEventListener('click', async () => {
          if (!trigger.dataset.pvpSrc) return;
          lastTrigger = trigger;
          const index = Number(trigger.dataset.pvpIndex) || 0;
          if (typeof dialog.showModal === 'function') dialog.showModal();
          else dialog.setAttribute('open', '');
          document.documentElement.style.overflow = 'hidden';
          document.body.style.overflow = 'hidden';
          await loadItem(index);
          showHintOnce();
        });
      }

      soundButton?.addEventListener('click', async () => {
        if (!player) return;
        player.muted = !player.muted;
        if (!player.muted) {
          player.defaultMuted = false;
          player.removeAttribute('muted');
          player.volume = 1;
          try { await player.play(); } catch (_error) {}
        }
        updateUi();
      });

      dialog.addEventListener('wheel', (event) => {
        if (Math.abs(event.deltaY) < 12) return;
        event.preventDefault();
        if (wheelLock) return;
        wheelLock = true;
        stepBy(event.deltaY > 0 ? 1 : -1);
        window.setTimeout(() => {
          wheelLock = false;
        }, 220);
      }, { passive: false });

      dialog.addEventListener('touchstart', (event) => {
        touchStartY = event.touches[0]?.clientY || 0;
      }, { passive: true });

      dialog.addEventListener('touchend', (event) => {
        const touchEndY = event.changedTouches[0]?.clientY || 0;
        const deltaY = touchStartY - touchEndY;
        if (Math.abs(deltaY) < 40) return;
        stepBy(deltaY > 0 ? 1 : -1);
      }, { passive: true });

      const handleClose = () => {
        if (player) {
          player.pause();
          player.currentTime = 0;
          player.removeAttribute('src');
          player.innerHTML = '';
        }
        activeIndex = 0;
        wheelLock = false;
        window.clearTimeout(hintTimer);
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
        if (typeof dialog.close === 'function') dialog.close();
        if (lastTrigger) {
          lastTrigger.focus();
          lastTrigger = null;
        }
      };

      for (const btn of closeButtons) btn.addEventListener('click', handleClose);

      dialog.addEventListener('cancel', (e) => {
        e.preventDefault();
        handleClose();
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) handleClose();
      });
    }

    const init = () => {
      for (const root of document.querySelectorAll(ROOT_SELECTOR)) bind(root);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const el = event.target;
      if (!el) return;
      const root = el.querySelector ? el.querySelector(ROOT_SELECTOR) : null;
      if (root) bind(root);
      else if (el.matches && el.matches(ROOT_SELECTOR)) bind(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team-slider"] && !Shopify.designMode) return;
  try {
    
  class TeamSliderCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.team-slider__track');
      this.prev = this.querySelector('.team-slider__arrow--prev');
      this.next = this.querySelector('.team-slider__arrow--next');
      if (!this.track || !this.prev) return;

      this.prev.addEventListener('click', () => this.scrollByCard(-1));
      this.next.addEventListener('click', () => this.scrollByCard(1));
      this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      window.addEventListener('resize', () => this.updateArrows(), { passive: true });
      this.updateArrows();
    }

    cardStep() {
      const card = this.track.firstElementChild;
      if (!card) return this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    scrollByCard(direction) {
      const cards = [...this.track.children];
      const step = this.cardStep();
      const index = Math.round(this.track.scrollLeft / step) + direction;
      const clamped = Math.max(0, Math.min(cards.length - 1, index));
      this.animateTo(cards[clamped].offsetLeft);
    }

    /* Manual rAF: smooth scrollTo is cancelled by scroll-snap in Chrome */
    animateTo(target) {
      cancelAnimationFrame(this.rafId);
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.track.scrollLeft = target;
        return;
      }
      const from = this.track.scrollLeft;
      const distance = target - from;
      const duration = 360;
      let start;
      const tick = (now) => {
        if (start === undefined) start = now;
        const p = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - p, 3);
        this.track.scrollLeft = from + distance * eased;
        if (p < 1) this.rafId = requestAnimationFrame(tick);
      };
      this.rafId = requestAnimationFrame(tick);
    }

    updateArrows() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      this.prev.disabled = this.track.scrollLeft <= 1;
      this.next.disabled = this.track.scrollLeft >= maxScroll - 1;
    }
  }

  if (!customElements.get('team-slider-carousel')) {
    customElements.define('team-slider-carousel', TeamSliderCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slideshow"] && !Shopify.designMode) return;
  try {
    
  function initVisibleResults() {
    for (const section of document.querySelectorAll('.visible-results')) {
      const thumbs = section.querySelectorAll('[data-vr-trigger]');
      const total = thumbs.length;
      if (total === 0) return;

      function goTo(index) {
        for (const el of section.querySelectorAll('[data-vr-slide].is-active, [data-vr-trigger].is-active')) {
          el.classList.remove('is-active');
          if (el.hasAttribute('aria-selected')) el.setAttribute('aria-selected', 'false');
        }
        for (const el of section.querySelectorAll('[data-vr-slide="' + index + '"]')) {
          el.classList.add('is-active');
        }
        const thumb = section.querySelector('[data-vr-trigger="' + index + '"]');
        if (thumb) {
          thumb.classList.add('is-active');
          thumb.setAttribute('aria-selected', 'true');
        }
      }

      function getCurrent() {
        const active = section.querySelector('[data-vr-trigger].is-active');
        return active ? parseInt(active.dataset.vrTrigger, 10) : 0;
      }

      const media = section.querySelector('.visible-results__media');
      let startX = 0;
      let startY = 0;

      media?.addEventListener('touchstart', function (event) {
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
      }, { passive: true });

      media?.addEventListener('touchend', function (event) {
        const diffX = startX - event.changedTouches[0].clientX;
        const diffY = startY - event.changedTouches[0].clientY;
        const threshold = media.clientWidth * 0.55;
        if (Math.abs(diffX) > threshold && Math.abs(diffX) > Math.abs(diffY)) {
          const current = getCurrent();
          goTo((current + (diffX > 0 ? 1 : -1) + total) % total);
        }
      }, { passive: true });

      section.addEventListener('click', function (e) {
        const trigger = e.target.closest('[data-vr-trigger]');
        if (trigger) {
          goTo(trigger.dataset.vrTrigger);
          return;
        }

        const arrow = e.target.closest('[data-vr-arrow]');
        if (arrow) {
          const cur = getCurrent();
          if (arrow.dataset.vrArrow === 'next') {
            goTo((cur + 1) % total);
          } else {
            goTo((cur - 1 + total) % total);
          }
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVisibleResults);
  } else {
    initVisibleResults();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trustpilot-trust-strip"] && !Shopify.designMode) return;
  try {
    
  function initTpReviewsTickers(scope = document) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    scope.querySelectorAll('[data-tp-reviews-ticker]').forEach((ticker) => {
      if (ticker.dataset.ready === 'true') return;

      const track = ticker.querySelector('[data-tp-reviews-track]');
      const group = ticker.querySelector('[data-tp-reviews-group]');
      if (!track || !group || group.children.length === 0) return;

      const originalItems = Array.from(group.children);
      const minGroupWidth = ticker.offsetWidth + group.scrollWidth;

      while (group.scrollWidth < minGroupWidth) {
        originalItems.forEach((item) => {
          const itemClone = item.cloneNode(true);
          itemClone.setAttribute('aria-hidden', 'true');
          itemClone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
          group.appendChild(itemClone);
        });
      }

      const clone = group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-tp-reviews-group');
      clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));

      track.appendChild(clone);
      ticker.dataset.ready = 'true';
    });
  }

  initTpReviewsTickers();
  document.addEventListener('shopify:section:load', (event) => initTpReviewsTickers(event.target));

  } catch(e) { console.error(e); }
})();
})();
